module.exports = __webpack_public_path__ + "static/media/comarch.f99ce656.jpg";